<script>
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import { GroupFormContent } from '@client/pages/manage/groups/shared';

  import { GroupsService } from '@client/services/groups';

  import { appStore } from '@client/stores/app';

  import { GROUP_DEFAULTS } from '@client/enums';

  import { deepCopy } from '@common/utils/objects';

  const { addNotification } = getNotificationsContext();

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  let group = deepCopy(GROUP_DEFAULTS);
  let invalid = false;

  const notify = (text, error) => {
    addNotification({
      text,
      type: error ? 'error' : 'success',
      autohide: 2500,
      position: 'top-right'
    });
  };

  const executeCreateGroup = async () => {
    $appStore.loading = true;

    const response = await GroupsService.createGroup(group);

    $appStore.loading = false;

    if (response.status === 400) {
      notify($format('label.FAILURE.CREATE_GROUP', { values: { item: response.message } }), true);
      throw new Error(response.message);
    } else {
      notify($format('label.SUCCESS.CREATE_GROUP', { values: { item: response.groupname } }));
    }

    step.data = {
      id: response.groupname || group.groupname
    };

    return response;
  };

  const rollbackCreateGroup = async () => {
    if (!step.data?.id) {
      return; // Nothing to rollback
    }

    $appStore.loading = true;

    try {
      // Get the group that was created
      const allGroups = await GroupsService.getAll();
      const group = allGroups.find((g) => g.groupname === step.data.id);

      if (group) {
        // Delete the group
        await GroupsService.deleteGroup(group);
      }
    } catch (error) {
      console.error('Failed to rollback group creation:', error);
    } finally {
      $appStore.loading = false;
    }
  };

  $: if (onExecute !== null) {
    onExecute(executeCreateGroup);
  }

  $: if (onRollback !== null) {
    onRollback(rollbackCreateGroup);
  }

  $: nextDisabled = !group.groupname || invalid;
</script>

<div class="workflow-create-group">
  <GroupFormContent bind:group bind:invalid />
</div>

<style lang="scss">
  .workflow-create-group {
    :global {
      .section {
        &:first-child {
          margin-top: 0 !important;
        }
      }
    }
  }
</style>
